module.exports = __webpack_public_path__ + "img/incomeGreen.73050b42.png";